import React from 'react';
import {LayoutContainer, SidebarMenu, MenuItem, MenuLogoContainer, FullWidth, SidebarMenuHeader} from "./styles";
import {useLocation} from "react-router-dom";
import {ReactComponent as Logo} from '../../assets/images/logo_colorful_icon.svg';
import {ReactComponent as LogoLetter} from '../../assets/images/logo.svg';
import {ReactComponent as PlusIcon} from '../../assets/icons/plus.svg'
import {useDispatch, useSelector} from "react-redux";
import {useTranslation} from "react-i18next";
import {Topbar} from "../../components";
import {selectMenu} from "../../app/sidebarMenu/selectors";
import {toggleSideBarMenu} from "../../app/sidebarMenu/actions";

export function MainLayout({children}: any) {
    const location = useLocation()
    const sideBarMenu = useSelector(selectMenu)
    const {t} = useTranslation()
    const dispatch = useDispatch();

    const handleShowHideSideBarMenu = () => {
        dispatch(toggleSideBarMenu())
    }

    return <LayoutContainer>
        <SidebarMenu isOpen={sideBarMenu.isOpen}>
            <SidebarMenuHeader>
                <MenuLogoContainer>
                    <div>
                        <Logo width={33} height={33} style={{marginRight: '5px'}}/>
                    </div>
                    <div>
                        <LogoLetter width={99} height={18} style={{marginLeft: '5px'}}/>
                    </div>
                </MenuLogoContainer>
                <button onClick={handleShowHideSideBarMenu}>
                    <PlusIcon width={15} height={15}/>
                </button>
            </SidebarMenuHeader>
            <MenuItem to={'/'} state={{isActive: location.pathname === '/'}}>{t('dashboard')}</MenuItem>
            <MenuItem
                to={'/employees'}
                state={{
                    isActive:
                        location.pathname === '/employees' ||
                        location.pathname.startsWith('/employee/') ||
                        location.pathname.startsWith('/generate_quote/') ||
                        location.pathname.startsWith('/terminate_contract/') ||
                        location.pathname.startsWith('/payroll/')
                }}>
                {t('employees')}
        </MenuItem>
    </SidebarMenu>
    <FullWidth>
        <Topbar/>
        {children}
    </FullWidth>
</LayoutContainer>
}
